import store from '@/store';

const getLastEditValue = (name) => {
  const { lastEditValues } = store.state.formData;
  if (name in lastEditValues) {
    return lastEditValues[name];
  }
  return null;
};

export default getLastEditValue;
